import Runner from "../runner"

export default {
    'js$': (content, { jsLibs = {} }) => {
        try {
            let m = (new Runner).runJS(content, jsLibs)
            if (m && m.stack && m.message) {
                throw new Error(m.message)
            }

            return m
        } catch (err) {
            throw new Error(err.message)
        }
    },

    'svg$': (content) => {
        return content
    },

    'json$': (content) => {
        return JSON.parse(content)
    }
}